import { useState } from "react";
import { Link, NavLink, useNavigate } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { LinkLogo } from "@/components/Brand";

const links = [
  { to: "/#how-it-works", label: "How TENET Works" },
  { to: "/sacred-flame", label: "Sacred Flame" },
  { to: "/assessments", label: "Assessments" },
  { to: "/about", label: "About Jonathan" },
  { to: "/book", label: "Free Book" },
  { to: "/faq", label: "FAQ" },
  { to: "/zoom", label: "Weekly Session" },
  { to: "/members", label: "Members" },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();

  return (
    <header className="sticky top-0 z-50 backdrop-blur-md bg-[#FDFBF7]/85 border-b border-stone-200/70">
      <nav className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-12 h-16 flex items-center justify-between">
        <LinkLogo />

        <div className="hidden lg:flex items-center gap-7">
          {links.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              data-testid={`nav-link-${l.to.replace("/", "")}`}
              className={({ isActive }) =>
                `text-sm font-medium transition-colors hover:text-[#1F3D2E] ${
                  isActive ? "text-[#1F3D2E]" : "text-stone-600"
                }`
              }
            >
              {l.label}
            </NavLink>
          ))}
          <button
            data-testid="nav-consultation-cta"
            onClick={() => navigate("/consultation")}
            className="btn-terracotta rounded-full px-5 py-2.5 text-sm font-semibold"
          >
            Free Consultation
          </button>
        </div>

        <button
          className="lg:hidden text-stone-700 p-2"
          onClick={() => setOpen((v) => !v)}
          aria-label="Toggle menu"
          data-testid="nav-mobile-toggle"
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </nav>

      {open && (
        <div className="lg:hidden border-t border-stone-200/70 bg-[#FDFBF7] px-4 py-4 space-y-1" data-testid="nav-mobile-menu">
          {links.map((l) => (
            <Link
              key={l.to}
              to={l.to}
              onClick={() => setOpen(false)}
              data-testid={`nav-mobile-link-${l.to.replace("/", "")}`}
              className="block px-3 py-2.5 rounded-lg text-stone-700 hover:bg-stone-100 font-medium"
            >
              {l.label}
            </Link>
          ))}
          <button
            data-testid="nav-mobile-consultation-cta"
            onClick={() => {
              setOpen(false);
              navigate("/consultation");
            }}
            className="btn-terracotta w-full rounded-full px-5 py-3 text-sm font-semibold mt-2"
          >
            Free 30-Minute Consultation
          </button>
        </div>
      )}
    </header>
  );
}
